import {useParams} from 'react-router-dom';
import {DeviceHealth} from '../../../../../../../components/device-health/device-health';
import {CaregiverMode} from '../../../../../../../enums/caregiver-mode';

interface DeviceHealthProfessionalCaregiverOfficeScreenProps {
  canWrite: boolean;
}

export default function DeviceHealthProfessionalCaregiverOfficeScreen({
  canWrite,
}: DeviceHealthProfessionalCaregiverOfficeScreenProps) {
  // Get params
  let {deviceId}: {deviceId?: string} = useParams();

  return (
    <DeviceHealth
      deviceId={deviceId!}
      caregiverMode={CaregiverMode.Professional}
      canWrite={canWrite}
    />
  );
}
